// extracted by mini-css-extract-plugin
module.exports = {"firstCell":"AssetCell_firstCell__1AB4b","imageContainer":"AssetCell_imageContainer__31ph7","title":"AssetCell_title__3xNxv","subtitle":"AssetCell_subtitle__1qD6g"};